import styled from 'styled-components';

export const H4 = styled.div`
	font-weight: bold;
	font-size: 18px;
	line-height: 24px;
	color: rgba(9, 21, 38, 0.85);
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;
